import {
  CAPTIVE_PORTALS_REQUEST_GET,
  CAPTIVE_PORTALS_RESPONSE_GET_SUCCESS,
  CAPTIVE_PORTALS_RESPONSE_GET_FAIL,
  CAPTIVE_PORTAL_REQUEST_ADD,
  CAPTIVE_PORTAL_RESPONSE_ADD_FAIL,
  CAPTIVE_PORTAL_RESPONSE_ADD_SUCCESS,
  RESET_CAPTIVE_PORTAL_ADD,
  SET_CAPTIVE_PORTAL_NAME,
  SET_SELECT_PLAN_NAME,
  SET_TYPE,
  SET_SPLASH_URL,
  SET_HOME_PAGE_URL,
  SET_IOCP,
  SET_EXT_SERVER_IP,
  SET_ENCRYPTION,
  SET_SELECT_PLAN,
  SET_BACKGROUND,
  SET_TILE_POSITION,
  SET_MOBILE_LOGO_POSITION,
  SET_MOBILE_TILE_POSITION,
  SET_WALLED_GARDEN_ENABLE,
  SET_WHITE_LIST_URL,
  SET_SECURE_LOGON,
  SET_RADIUS_SERVER_ID,
  CAPTIVE_PORTAL_REQUEST_PUT,
  CAPTIVE_PORTAL_RESPONSE_PUT_FAIL,
  DELETE_CAPTIVE_PORTAL_RESPONSE_SUCCESS,
  RESET_CAPTIVE_PORTAL_DELETE,
  CAPTIVE_PORTAL_SELECTED,
  SET_LOGO_ONE,
  SET_LOGO_ONE_CONFIG,
  SET_LOGO_TWO,
  SET_LOGO_TWO_CONFIG,
  ENABLE_TERMS_CONDITIONS,
  SET_TERMS_CONDITIONS,
  SET_TERMS_CONDITIONS_CONFIG,
  SET_TITLE_ONE_CONFIG,
  SET_TITLE_TWO_CONFIG,
  SET_TITLE_THREE_CONFIG,
  SET_AUTHENTICATION_TYPE_CONFIG,
  GET_SPLASH_ID,
  GET_CAPTIVE_ID,
  RESET_CAPTIVE_PORTAL_EDIT,
  CAPTIVE_PORTAL_RESPONSE_PATCH_FAIL,
  CAPTIVE_PORTAL_REQUEST_PATCH,
  EDIT_CAPTIVE_PORTAL_RESPONSE_SUCCESS,
  GET_LB_IP,
  SET_ENCRYPTION_PASSKEY,
  CAPTIVE_PORTAL_SELECTED_BULK,
  GET_AUTH_MODE,
  GET_UAM_PORT,
  GET_UAM_SECRET,
  GET_IDLE_TIMEOUT,
  GET_TIMEOUT,
  GET_CAPTIVE_VENDOR,
} from "../constants/captivePortalsConstants";

export const captivePortalsListReducer = (state = { captivePortals: {} }, action) => {
  switch (action.type) {
    case CAPTIVE_PORTALS_REQUEST_GET:
      return {
        ...state,
        loading: true,
      };
    case CAPTIVE_PORTALS_RESPONSE_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        captivePortals: action.payload,
      };
    case CAPTIVE_PORTALS_RESPONSE_GET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const captivePortalAddReducer = (
	state = {
    msg: null, error: null, data:[], loading: false,
	},
	action
) => {
	switch (action.type) {
		case CAPTIVE_PORTAL_REQUEST_ADD:
			return { ...state, loading: true, error: null };
		case CAPTIVE_PORTAL_RESPONSE_ADD_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case CAPTIVE_PORTAL_RESPONSE_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_CAPTIVE_PORTAL_ADD:
			return {
				...state,
				loading: false,
				msg: null,
				error: null,
				data: [],
			};
		default:
			return state;
	}
};
export const captivePortalEditReducer = (
    state = {
      captivePortalIdValue:'',
      captivePortalNameValue: '',
      selectPlanValue: '',
      typeValue: '',
	    splashUrlvalue: '',
	    homePageUrlvalue: '',
	    iocpValue: '',
      authModeValue:'',
      uamPortValue:'',
      uamSecretValue:'',
      idleTimeoutValue:'',
      timeOutValue:'',
      captiveVendorValue:'',
	    extServerIpValue: '',
	    encryptionValue: '',
      encryptionPasskeyValue:'',
	    selectPlanValue: '',
	    
	    mobileLogoPositionValue: '',
	    mobileTilePositionValue: '',
	    walledGardenEnableValue: '',
	    whiteListUrlValue: '',
	    secureLogonValue: '',
	    radiusServerIdValue: '',
      lbIp:'',

      splashIdvalue:'',
      uploadedBackgroundValue: '',
      uploadedLogoOneValue:'',
      uploadedLogoOneConfigValue:'',
      uploadedLogoTwoValue:'',
      uploadedLogoTwoConfigValue:'',
      enableTermsConditionsValue:'',
      termsConditionsValue:'',
      termsConditionsConfigValue:'',
      titleOneConfigValue:'',
      titleTwoConfigValue:'',
      titleThreeConfigValue:'',
      tilePositionValue: '',
      authenticationTypeConfigValue:'',

    },
    action
  ) => {
    switch (action.type) {
      case GET_CAPTIVE_ID:
        return {
          ...state,
          captivePortalIdValue: action.payload,
        };
      case SET_CAPTIVE_PORTAL_NAME:
        return {
          ...state,
          captivePortalNameValue: action.payload,
        };
        case SET_SELECT_PLAN_NAME:
        return {
          ...state,
          selectPlanValue: action.payload,
        };
        case SET_TYPE:
        return {
          ...state,
          typeValue: action.payload,
        };
		case SET_SPLASH_URL:
        return {
          ...state,
          splashUrlvalue: action.payload,
        };
		case SET_HOME_PAGE_URL:
        return {
          ...state,
          homePageUrlvalue: action.payload,
        };
		case SET_IOCP:
        return {
          ...state,
          iocpValue: action.payload,
        };
    case GET_AUTH_MODE:
    return {
      ...state,
      authModeValue: action.payload,
    };
    case GET_UAM_PORT:
    return {
      ...state,
      uamPortValue: action.payload,
    };
    case GET_UAM_SECRET:
    return {
      ...state,
      uamSecretValue: action.payload,
    };
    case GET_IDLE_TIMEOUT:
    return {
      ...state,
      idleTimeoutValue: action.payload,
    };
    case GET_TIMEOUT:
    return {
      ...state,
      timeOutValue: action.payload,
    };
    case GET_CAPTIVE_VENDOR:
    return {
      ...state,
      captiveVendorValue: action.payload,
    };
		case SET_EXT_SERVER_IP:
        return {
          ...state,
          extServerIpValue: action.payload,
        };
		case SET_ENCRYPTION:
        return {
          ...state,
          encryptionValue: action.payload,
        };
    case SET_ENCRYPTION_PASSKEY:
      return {
        ...state,
        encryptionPasskeyValue: action.payload,
      };    
		case SET_SELECT_PLAN:
        return {
          ...state,
          selectPlanValue: action.payload,
        };
        case GET_SPLASH_ID:
        return {
          ...state,
          splashIdvalue: action.payload,
        };
		case SET_BACKGROUND:
        return {
          ...state,
          uploadedBackgroundValue: action.payload,
        };
		case SET_LOGO_ONE:
        return {
          ...state,
          uploadedLogoOneValue: action.payload,
        };
        case SET_LOGO_ONE_CONFIG:
          return {
            ...state,
            uploadedLogoOneConfigValue: action.payload,
          };   
          case SET_LOGO_TWO:
        return {
          ...state,
          uploadedLogoTwoValue: action.payload,
        };
        case SET_LOGO_TWO_CONFIG:
          return {
            ...state,
            uploadedLogoTwoConfigValue: action.payload,
          };  
    case ENABLE_TERMS_CONDITIONS:
        return {
          ...state,
          enableTermsConditionsValue: action.payload,
        };
        case SET_TERMS_CONDITIONS:
        return {
          ...state,
          termsConditionsValue: action.payload,
        };
        case SET_TERMS_CONDITIONS_CONFIG:
        return {
          ...state,
          termsConditionsConfigValue: action.payload,
        };
        case SET_TITLE_ONE_CONFIG:
        return {
          ...state,
          titleOneConfigValue: action.payload,
        };
        case SET_TITLE_TWO_CONFIG:
        return {
          ...state,
          titleTwoConfigValue: action.payload,
        };    
		case SET_TITLE_THREE_CONFIG:
        return {
          ...state,
          titleThreeConfigValue: action.payload,
        };
		case SET_TILE_POSITION:
        return {
          ...state,
          tilePositionValue: action.payload,
        };
        case SET_AUTHENTICATION_TYPE_CONFIG:
          return {
            ...state,
            authenticationTypeConfigValue: action.payload,
          };    
		case SET_MOBILE_LOGO_POSITION:
        return {
          ...state,
          mobileLogoPositionValue: action.payload,
        };
		case SET_MOBILE_TILE_POSITION:
        return {
          ...state,
          mobileTilePositionValue: action.payload,
        };
		case SET_WALLED_GARDEN_ENABLE:
        return {
          ...state,
          walledGardenEnableValue: action.payload,
        };
		case SET_WHITE_LIST_URL:
        return {
          ...state,
          whiteListUrlValue: action.payload,
        };
    case GET_LB_IP:
    return {
      ...state,
      lbIp: action.payload,
    };
		case SET_SECURE_LOGON:
        return {
          ...state,
          secureLogonValue: action.payload,
        };
		case SET_RADIUS_SERVER_ID:
        return {
          ...state,
          radiusServerIdValue: action.payload,
        };
        case RESET_CAPTIVE_PORTAL_EDIT:
        return {
          ...state,
          captivePortalIdValue:'',
      captivePortalNameValue: '',
      selectPlanValue: '',
      typeValue: '',
	    splashUrlvalue: '',
	    homePageUrlvalue: '',
	    iocpValue: '',
      authModeValue:'',
      uamPortValue:'',
      uamSecretValue:'',
      idleTimeoutValue:'',
      timeOutValue:'',
      captiveVendorValue:'',
	    extServerIpValue: '',
	    encryptionValue: '',
      encryptionPasskeyValue:'',
	    selectPlanValue: '',
	    
	    mobileLogoPositionValue: '',
	    mobileTilePositionValue: '',
	    walledGardenEnableValue: '',
	    whiteListUrlValue: '',
	    secureLogonValue: '',
	    radiusServerIdValue: '',
      lbIp:'',

      splashIdvalue:'',
      uploadedBackgroundValue: '',
      uploadedLogoOneValue:'',
      uploadedLogoOneConfigValue:'',
      uploadedLogoTwoValue:'',
      uploadedLogoTwoConfigValue:'',
      enableTermsConditionsValue:'',
      termsConditionsValue:'',
      termsConditionsConfigValue:'',
      titleOneConfigValue:'',
      titleTwoConfigValue:'',
      titleThreeConfigValue:'',
      tilePositionValue: '',
      authenticationTypeConfigValue:'',
        };
        
      default:
        return state;
    }
  };

  export const captivePortalDeleteReducer =  (state = { successMessageOnDelete:null, deleteError: null, data:[], loading: false}, action) => {
    switch (action.type) {
      case CAPTIVE_PORTAL_REQUEST_PUT:		
        return {
          ...state,
          loading: true,
          deleteError : null
        };	
      case CAPTIVE_PORTAL_RESPONSE_PUT_FAIL:
        return {
          ...state,
          loading: false,
          ...action.payload,
        };
      case DELETE_CAPTIVE_PORTAL_RESPONSE_SUCCESS:
        return {
          ...state,
          loading: false,
          ...action.payload,
        };
      case RESET_CAPTIVE_PORTAL_DELETE: 
        return {
          ...state,
          loading: false,
          successMessageOnDelete: null,
          deleteError: null,
          data: []
        }
      default:
        return state;
    }
  }

  export const captivePortalSelectReducer = (
    state = {
      captivePortalSelected : {},
      captivePortalSelectedBulk : {},
    }, 
    action
) => {
	switch (action.type) {
		case CAPTIVE_PORTAL_SELECTED:
			return { 
                ...state,
                captivePortalSelected: action.payload
            };     	
    case CAPTIVE_PORTAL_SELECTED_BULK:
      return { 
                ...state,
                captivePortalSelectedBulk: action.payload
            };
       
    default:
			return state;
	}
};

export const captivePortalEditStateReducer = (
	state = {
    msg: null, error: null, data:[], loading: false,
	},
	action
) => {
	switch (action.type) {
		case CAPTIVE_PORTAL_REQUEST_PATCH:
			return { ...state, loading: true, error: null };
		case CAPTIVE_PORTAL_RESPONSE_PATCH_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case EDIT_CAPTIVE_PORTAL_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_CAPTIVE_PORTAL_ADD:
			return {
				...state,
				loading: false,
				msg: null,
				error: null,
				data: [],
			};
		default:
			return state;
	}
};